/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_North_AmericaInputs */

const bn_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উত্তর আমেরিকা`)
};

const de_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nordamerika`)
};

const el_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Βόρεια Αμερική`)
};

const en_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`North America`)
};

const es_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`América del norte`)
};

const fr_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amérique du Nord`)
};

const hi_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तरी अमेरिका`)
};

const hu_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Észak Amerika`)
};

const id_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerika Utara`)
};

const it_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`America del Nord`)
};

const ja_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北米`)
};

const ko_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`북아메리카`)
};

const nl_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noord-Amerika`)
};

const pl_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ameryka Północna`)
};

const pt_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`América do Norte`)
};

const ru_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Северная Америка`)
};

const sv_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nordamerika`)
};

const tr_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuzey Amerika`)
};

const uk_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Північна Америка`)
};

const vi_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắc Mỹ`)
};

const zh_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北美`)
};

const zh_hant_region_north_america = /** @type {(inputs: Region_North_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`北美洲`)
};

/**
* | output |
* | --- |
* | "North America" |
*
* @param {Region_North_AmericaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_north_america = /** @type {((inputs?: Region_North_AmericaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_North_AmericaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_north_america(inputs)
	if (locale === "de") return de_region_north_america(inputs)
	if (locale === "el") return el_region_north_america(inputs)
	if (locale === "en") return en_region_north_america(inputs)
	if (locale === "es") return es_region_north_america(inputs)
	if (locale === "fr") return fr_region_north_america(inputs)
	if (locale === "hi") return hi_region_north_america(inputs)
	if (locale === "hu") return hu_region_north_america(inputs)
	if (locale === "id") return id_region_north_america(inputs)
	if (locale === "it") return it_region_north_america(inputs)
	if (locale === "ja") return ja_region_north_america(inputs)
	if (locale === "ko") return ko_region_north_america(inputs)
	if (locale === "nl") return nl_region_north_america(inputs)
	if (locale === "pl") return pl_region_north_america(inputs)
	if (locale === "pt") return pt_region_north_america(inputs)
	if (locale === "ru") return ru_region_north_america(inputs)
	if (locale === "sv") return sv_region_north_america(inputs)
	if (locale === "tr") return tr_region_north_america(inputs)
	if (locale === "uk") return uk_region_north_america(inputs)
	if (locale === "vi") return vi_region_north_america(inputs)
	if (locale === "zh") return zh_region_north_america(inputs)
	return zh_hant_region_north_america(inputs)
});